module.exports = __webpack_public_path__ + "img/parallax-one.ed2e221.jpg";